
import PropTypes from "prop-types";
import { useState } from "react";
import { Typography, TextField } from "@mui/material";


function PhoneNumber({
  label,
  inputLabel,
  formState,
  setFormState,
  setFormError,
}) {
  const [ value, setValue ] = useState("");

  function onChange(e) {
    const inputValue = e.target.value;
    let inputValid = false;

    const alphanumericRegex = /^[a-z0-9]+$/i;
    inputValid = alphanumericRegex.test(inputValue) || inputValue === "";

    if (inputValid) {
      const upperCasedValue = inputValue.toUpperCase();
      setValue(upperCasedValue);
      setFormState({
        ...formState,
        [e.target.name]: upperCasedValue,
      });
      setFormError(null);
    }
  }

  return (
    <>
      <Typography
        id='phoneNumberLabel'
        component='label'
        htmlFor='phoneNumberInput'
        sx={{
          fontWeight: "bold"
        }}
      >
        {label}
      </Typography>
      <TextField
        id='phoneNumberInput'
        margin='dense'
        required
        fullWidth
        label={inputLabel}
        name='phoneNumber'
        onChange={onChange}
        value={value}
        inputProps={{ maxLength: 11 }}
      />
    </>
  );
};

const validatePhoneNumber = (phoneNumber) => {
  const regex = /^\d{11}$/;
  console.log("*** validate mobile number ***: ", regex.test(phoneNumber))
  return regex.test(phoneNumber);
};

PhoneNumber.propTypes = {
  label: PropTypes.string.isRequired,
  inputLabel: PropTypes.string.isRequired,
  formState: PropTypes.object.isRequired,
  setFormState: PropTypes.func.isRequired,
  setFormError: PropTypes.func.isRequired,
};

export { PhoneNumber, validatePhoneNumber };